import React, { useCallback } from 'react';
import { useGame } from '../context/GameContext.jsx';

const OutcomeScreen = () => {
  const { outcomeCardData, translations, lang, resetGame } = useGame();

  const fallbackCard = {
    Code: 'DD',
    Type: 'story',
    Category: 'defeat',
    Title: translations[lang]?.game_over_main_text,
    Subtitle: translations[lang]?.game_over_message,
    FieldValue: translations[lang]?.no_outcome_card_found
  };

  const displayCard = outcomeCardData || fallbackCard;

  const getOutcomeImagePath = useCallback((card) => {
    if (card.Image && card.Image.trim() !== '') {
      return `/assets/cards/${card.Image}`;
    }
    return `/assets/cards/${card.Category.toLowerCase()}.png`;
  }, []);

  const imageUrl = getOutcomeImagePath(displayCard);

  const handleReturnToHome = useCallback(() => {
    console.log('OutcomeScreen: Return to Home button clicked. Resetting game.');
    resetGame();
  }, [resetGame, translations, lang]);

  return (
    <div className="screen-visible d-flex flex-column align-items-center justify-content-center outcome-screen">
      <h1 className="text-light mt-4 text-center px-3">{displayCard.Subtitle}</h1>
      
      <img
        src={imageUrl}
        alt={displayCard.Title || translations[lang]?.outcome_card_alt}
        className="outcome-image mb-3"
        style={{ maxWidth: '300px', height: 'auto', borderRadius: '8px' }}
      />

      <h2 className="text-light mt-4 text-center px-3">{displayCard.Title}</h2>
      
      {displayCard.FieldValue && <p className="text-light text-center px-4">{displayCard.FieldValue}</p>}
      
      <button
        className="btn btn-light mt-3"
        onClick={handleReturnToHome}
      >
        {translations[lang]?.return_to_home_button}
      </button>
    </div>
  );
};

export default OutcomeScreen;
